import * as React from 'react';
import styled from '@emotion/styled';
import { observer } from 'src/utils/mobx-react';

interface PropsType {
    className?: string;
    onClick?: () => void;
}

const SvgElement = styled('svg', { label: 'SvgElement' })`
    height: auto;
`;

export const BetGliderCta = observer('BetGliderCta', ({ className, onClick }: PropsType): JSX.Element => {
    return (
        <SvgElement
            xmlns='http://www.w3.org/2000/svg'
            width='107'
            height='24'
            viewBox='0 0 107 24'
            fill='none'
            className={className}
            onClick={onClick}
        >
            <g clipPath='url(#betGliderClipPath)'>
                <rect
                    width='107'
                    height='24'
                    fill='#e30613'
                    rx='4'
                />
                <g
                    fill='#1d1d1b'
                    fillOpacity='.12'
                    filter='url(#betGliderInnerShadow)'
                    opacity='.4'
                >
                    <path d='M20.404 6.925c1.897.823 2.838 2.814 2.397 5.074s-2.156 4.24-4.372 5.073L2.896 22.909 0 24l1.326-6.776L15.226 12 3.367 6.778 4.695 0z' />
                    <path d='M39.714 6.925C41.61 7.748 42.55 9.74 42.11 12s-2.156 4.24-4.372 5.073l-15.532 5.837L19.309 24l1.326-6.776L34.535 12 22.677 6.778 24.004 0z' />
                    <path d='M59.023 6.925C60.92 7.748 61.86 9.74 61.419 12s-2.156 4.24-4.372 5.073l-15.532 5.837L38.618 24l1.326-6.776L53.844 12 41.986 6.778 43.313 0z' />
                    <path d='M78.332 6.925c1.897.823 2.838 2.814 2.396 5.074-.441 2.26-2.155 4.24-4.372 5.073l-15.532 5.837L57.927 24l1.326-6.776L73.153 12 61.295 6.778 62.622 0z' />
                    <path d='M97.64 6.925c1.898.823 2.839 2.814 2.398 5.074s-2.156 4.24-4.373 5.073l-15.532 5.837L77.237 24l1.326-6.776L92.462 12 80.605 6.778 81.93 0z' />
                    <path d='M116.95 6.925c1.897.823 2.838 2.814 2.397 5.074s-2.156 4.24-4.373 5.073l-15.532 5.837L96.546 24l1.326-6.776L111.77 12 99.914 6.778 101.24 0z' />
                    <path d='M136.259 6.925c1.897.823 2.838 2.814 2.397 5.074s-2.156 4.24-4.373 5.073l-15.532 5.837L115.855 24l1.326-6.776L131.08 12l-11.857-5.223L120.55 0z' />
                    <path d='M155.568 6.925c1.897.823 2.838 2.814 2.397 5.074s-2.156 4.24-4.373 5.073l-15.531 5.837L135.164 24l1.326-6.776L150.389 12l-11.857-5.223L139.859 0z' />
                    <path d='M174.878 6.925c1.897.823 2.837 2.814 2.396 5.074s-2.156 4.24-4.373 5.073l-15.531 5.837L154.473 24l1.326-6.776L169.698 12l-11.857-5.223L159.168 0z' />
                    <path d='M194.187 6.925c1.897.823 2.837 2.814 2.396 5.074s-2.156 4.24-4.372 5.073l-15.532 5.837L173.782 24l1.326-6.776L189.007 12 177.15 6.778 178.477 0z' />
                    <path d='M213.496 6.925c1.897.823 2.838 2.814 2.397 5.074s-2.156 4.24-4.373 5.073l-15.532 5.837L193.091 24l1.326-6.776L208.316 12l-11.857-5.223L197.786 0zM1.326 17.224h-.002l.002-.002zM20.635 17.224h-.002l.003-.002zM39.944 17.224h-.002l.003-.002zM59.253 17.224h-.002l.003-.002zM78.563 17.224h-.002l.002-.002zM97.872 17.224h-.002l.002-.002zM117.181 17.224h-.002l.002-.002zM136.49 17.224h-.002l.002-.002zM155.799 17.224h-.002l.002-.002zM175.108 17.224h-.002l.002-.002z' />
                    <path d='M194.417 17.224h-.002l.003-.002z' />
                </g>
                <path
                    fill='#fff'
                    d='M12 7.767h6.564q1.337 0 2.034.581.674.558.675 1.597c0 .966-.44 1.617-1.312 1.947q1.675.422 1.673 2.105 0 1.065-.7 1.647-.72.594-2.083.594H12zm3.132 3.144h2.445q.567.002.568-.426 0-.426-.568-.425h-2.445zm0 3.02h2.807q.568.001.568-.425 0-.427-.568-.426h-2.807zM31.26 7.767v2.418h-5.782v.726h5.665v2.18h-5.665v.726h5.783v2.418h-8.916V7.767zM40.888 7.767v2.662h-3.131v5.806h-3.132v-5.806h-3.132V7.767h9.396zM64.054 14.612l7.04-2.611-6.005-2.612L65.761 6l7.956 3.463c.96.411 1.437 1.407 1.214 2.536s-1.092 2.12-2.215 2.537l-7.866 2.919-1.467.545.672-3.39zM85.214 7.767l-.479 2.418h-5.782l-.144.726h5.664l-.431 2.18h-5.665l-.144.726h5.783l-.48 2.418h-8.915L76.3 7.767zM87.381 16.23H84.25l1.677-8.463h5.577c1.323 0 2.282.289 2.865.87q.858.836.55 2.394c-.261 1.317-.983 2.241-2.167 2.782l1.136 2.418h-3.25l-.907-1.936h-1.966zm.91-4.593h2.552q.82 0 .938-.606.12-.606-.698-.606h-2.552l-.24 1.213M56.4 7.767l-1.15 5.806h4.817l-.528 2.662h-7.95l1.678-8.468zM61.748 7.767h3.132l-1.678 8.468h-3.131zM46.437 11.275l-.36 1.816h2.002q-.725.846-2.17.846-2.288.001-1.906-1.936.385-1.937 2.673-1.936 1.324.002 1.76.726h3.363q-.072-1.511-1.228-2.31c-.786-.558-1.927-.834-3.41-.834q-2.663-.002-4.29 1.148Q41.287 9.92 40.875 12q-.413 2.08.726 3.206 1.171 1.146 3.834 1.148 2.263 0 3.778-.831l-.141.71h1.808l.983-4.96z'
                />
            </g>
            <defs>
                <clipPath id='betGliderClipPath'>
                    <rect
                        width='107'
                        height='24'
                        fill='#fff'
                        rx='4'
                    />
                </clipPath>
                <filter
                    id='betGliderInnerShadow'
                    width='216'
                    height='24'
                    x='0'
                    y='0'
                    colorInterpolationFilters='sRGB'
                    filterUnits='userSpaceOnUse'
                >
                    <feFlood
                        floodOpacity='0'
                        result='BackgroundImageFix'
                    />
                    <feBlend
                        in='SourceGraphic'
                        in2='BackgroundImageFix'
                        result='shape'
                    />
                    <feColorMatrix
                        in='SourceAlpha'
                        result='hardAlpha'
                        values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
                    />
                    <feOffset />
                    <feGaussianBlur stdDeviation='2.5' />
                    <feComposite
                        in2='hardAlpha'
                        k2='-1'
                        k3='1'
                        operator='arithmetic'
                    />
                    <feColorMatrix values='0 0 0 0 0.0784314 0 0 0 0 0.14902 0 0 0 0 0.203922 0 0 0 0.24 0' />
                    <feBlend
                        in2='shape'
                        result='effect1_innerShadow_395_33158'
                    />
                </filter>
            </defs>
        </SvgElement>
    );
});
